import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowSkip = () => {
  return (
    <g>
      <path d="m7.7925 7.7344a2.2473 2.2473 0 1 0 2.2475 2.2475 2.25 2.25 0 0 0 -2.2475-2.2475zm0 2.9946a.7473.7473 0 1 1 .7475-.7471.7481.7481 0 0 1 -.7475.7471z" />
      <path d="m15.6963 8.4951a.75.75 0 0 0 -1.0605 0l-.6894.6894a6.1941 6.1941 0 0 0 -11.9356-1.4177 2.2477 2.2477 0 1 0 1.4834.3015 4.7067 4.7067 0 0 1 8.9123.9623l-.5355-.5355a.75.75 0 0 0 -1.0605 1.0605l1.9126 1.9126a.75.75 0 0 0 1.0605 0l1.9126-1.9126a.75.75 0 0 0 .0001-1.0605z" />
    </g>
  );
};

export default withIcon(IconArrowSkip);
